var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"login-sns-each"},[_c(_setup.buttonComponents[_vm.snsType],_vm._b({tag:"component",on:{"success":_setup.onSuccessConnect,"fail":_vm.onFailConnect}},'component',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }